import { render, staticRenderFns } from "./LoginRedirectRoot.vue?vue&type=template&id=1f5423e6"
import script from "./LoginRedirectRoot.vue?vue&type=script&lang=ts"
export * from "./LoginRedirectRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports